import React from "react"

import { DescriptionItem } from "~tailwindui/Basics"
import Panel from "~tailwindui/Basics/Panel"

import titlecase from "src/titlecase"

import LocalTime from "components/LocalTime"

import AcceptReplacementRequest from "./AcceptReplacementRequest"

export type ReplacementCardProps = {
  replacement: {
    id: string
    startsAt: string
    details: string
    originalTutor: {
      id: string
      fullName: string
    }
    studyGroup: {
      id: string
      name: string
      details: string
      subjects: {
        id: string
        name: string
      }[]
      organization: {
        id: string
        name: string
        details: string
        emailTimeZone: string
      }
      courseSection: {
        id: string
        endsOn: string
      }
      foreignLanguage: {
        id: string
        name: string
      }
      allAvailabilities: {
        id: string
        startsAt: string
        endsAt: string
        weekday: string
      }[]
    }
  }
}

const ReplacementCard: React.FC<ReplacementCardProps> = ({ replacement }) => {
  return (
    <Panel className="max-w-lg">
      <div className="flex flex-1 flex-col items-center justify-between space-y-3 py-4 px-6">
        <div className="text-center text-lg font-bold text-green-600">
          <span>
            Starting on <LocalTime omitTime timestamp={replacement.startsAt} />
          </span>
          <div className="font-medium text-orange-600">
            {replacement.studyGroup.foreignLanguage?.name}
          </div>
        </div>

        <div className="text-sm">
          <DescriptionItem
            label="Meeting Times"
            value={
              <ul>
                {replacement.studyGroup.allAvailabilities.map(availability => (
                  <li key={availability.id}>
                    {titlecase(availability.weekday)}{" "}
                    <LocalTime omitDate timestamp={availability.startsAt} /> -{" "}
                    <LocalTime
                      timestamp={availability.endsAt}
                      format="h:mm A (z)"
                    />
                  </li>
                ))}
              </ul>
            }
          />

          <DescriptionItem
            label="Original Tutor"
            value={replacement.originalTutor.fullName}
          />
          <DescriptionItem label="Notes" value={replacement.details} />
          <DescriptionItem
            label="Subject"
            value={replacement.studyGroup.subjects
              .map(subject => subject.name)
              .join(", ")}
          />
          <DescriptionItem
            label="Study Group"
            value={replacement.studyGroup.name}
          />
          {replacement.studyGroup.details && (
            <DescriptionItem
              label="Study Group Details"
              value={replacement.studyGroup.details}
            />
          )}
          {replacement.studyGroup.organization && (
            <>
              <DescriptionItem
                label="Organization"
                value={replacement.studyGroup.organization.name}
              />
              {replacement.studyGroup.organization.details && (
                <DescriptionItem
                  label="Organization Details"
                  value={replacement.studyGroup.organization.details}
                />
              )}
              <DescriptionItem
                label="Organization Time Zone"
                value={replacement.studyGroup.organization.emailTimeZone}
              />
            </>
          )}
        </div>
      </div>

      <div className="flex w-full items-center justify-center gap-4">
        <AcceptReplacementRequest
          studyGroupTutorReplacementId={replacement.id}
        />
      </div>
    </Panel>
  )
}

export default ReplacementCard
